import { CIcon } from '~/icons/types'

export const ciPlayCircle: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8Z'
    },
    {
      d:
        'm15.515 11.143-5-3A1 1 0 0 0 9 9v6a1.001 1.001 0 0 0 1.515.857l5-3a1 1 0 0 0 0-1.713ZM11 13.233v-2.466L13.057 12 11 13.232Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'play-circle',
  type: 'regular'
}
